import styled from 'styled-components'

export const LegendColor = styled.div<{ color: string }>`
  width: 11px;
  height: 11px;
  background-color: ${({ color }): string => color};
  border-radius: 50%;
`
export const LegendLabel = styled.div`
  font-size: 11px;
  color: black;
`

export const LegendWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
`

export const ChartContent = styled.div<{ width: string }>`
  width: ${({ width }): string => width};
  overflow: hidden;
`

export const ChartContentWrapper = styled.div`
  height: 338px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 5px;
  white-space: nowrap;
  overflow: hidden;
  @media (max-width: 980px) {
    max-width: 775px;
  }
  ::-webkit-scrollbar {
    height: 8px;
  }

  ::-webkit-scrollbar-thumb {
    background: rgba(136, 136, 136, 0.78);
    border-radius: 8px;
  }

  :hover {
    overflow-x: auto;
  }
`

export const ChartWrapper = styled.div`
  display: flex;
  gap: 30px;
  flex-direction: column;
  width: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
  position: relative;
  z-index: 0;
`
